import {Component, inject, signal} from '@angular/core';
import {MultiTreeSelect} from '../ui/multi-tree-select/multi-tree-select';
import {FacetKey, FacetNode} from '../domain/search.model';
import {SearchFacade} from '../application/search.facade';
import {VuiButton} from '@viessmann/ui/button';

@Component({
  selector: 'app-search-page',
  imports: [
    MultiTreeSelect,
    VuiButton
  ],
  templateUrl: './search-page.html',
  styleUrl: './search-page.scss',
})
export class SearchPage {
  private readonly _facade = inject(SearchFacade);
  protected readonly resetVersion = signal(0);

  protected readonly facetKeys = Object.values(FacetKey);

  protected readonly facetLabels: Record<FacetKey, string> = {
    [FacetKey.PRODUCTS]: 'Wärmeerzeuger Einzelgeräte',
    [FacetKey.PRODUCTS_CASCADE]: 'Wärmeerzeuger Kaskade',
    [FacetKey.CONTROL_PLATFORMS]: 'Regelungsplattform',
  };

  protected readonly facetNodes = this._facade.facetNodes;

  protected updateFilters(key: FacetKey, facets: FacetNode[]) {
    this._facade.search(key, facets);
  }

  protected resetFilters(): void {
    this._facade.resetFilters();
    this.resetVersion.update(value => value + 1);
  }
}
